const SuggestionMenu = {
	how_improve: 'Como podemos melhorar?',
	placeholder: 'Resumo sobre sua sugestão',
	pending: 'Pendente',
	in_progress: 'Em progresso',
	completed: 'Completado',
	search: 'Busca'
}

export default SuggestionMenu;